
/**
 * An object representing user roles in the application.
 * 
 * @constant {Object} ROLES
 * @property {string} CUSTOMER - Represents the customer role.
 * @property {string} VENDOR - Represents the vendor role.
 */
export const ROLES = {
    CUSTOMER: "customer",
    VENDOR:"vendor"
};




export const steps = [
    {
      step: 1,
      title: "Preapproval application",
      questions: [
        {
          question: "You want to talk to the broker about?",
          options: [
            "Buying my first home",
            "Investment property",
            "Refinance existing loan",
            "Debt consolidation",
          ],
        },
        {
          question: "What’s your home loan situation?",
          options: [
            "Exploring my options",
            "Buying in the next 6 months",
            "Actively house hunting",
            "Finalizing the purchase",
          ],
        },
        {
          question: "How would you describe your credit history?",
          options: [
            "Great - No credit issues",
            "Okay - Had a default but sorted it",
            "Needs work - Let's discuss your options",
            "Not sure - We'll help you understand",
          ],
        },
      ],
    },
    {
      step: 2,
      title: "Preapproval application",
      questions: [
        {
          question: "How do you earn a living?",
          options: [
            "I work for a company (employee)",
            "I own a business (self-employed)",
            "Other – Let’s discuss",
          ],
        },
        {
          question: "How many applicants are there?",
          options: ["1 Applicant", "2 applicants"],
        },
        {
          question: "Source of income",
          options: [
            "Full-time/part-time employment",
            "Self-employment",
            "Trusts or investments",
            "Australian defence force",
            "Currently unemployed",
          ],
        },
      ],
    },
    {
      step: 3,
      title: "Preapproval application",
      questions: [
        {
          title: "What is your income",
          min: 50,
          max: 300,
          step: 10,
          marks: [
            { value: 50, label: "50k" },
            { value: 100, label: "100k" },
            { value: 150, label: "150k" },
            { value: 200, label: "200k" },
            { value: 250, label: "250k" },
            { value: 300, label: "300k" },
          ],
        },
        {
          title: "What is your expected purchase price",
          min: 400,
          max: 2000,
          step: 100,
          marks: [
            { value: 400, label: "400k" },
            { value: 500, label: "500k" },
            { value: 600, label: "600k" },
            { value: 700, label: "700k" },
            { value: 800, label: "800k" },
            { value: 900, label: "900k" },
            { value: 1000, label: "1Mil" },
            { value: 2000, label: "2Mil" },
          ],
        },
        {
          title: "How much deposit do you have/saved?",
          min: 50,
          max: 300,
          step: 10,
        },
      ],
    },
    {
      step: 4,
      title: "Preapproval application",
    },
  ];
